import { CollapsibleContainer } from '../styled-components'
import { AnimatePresence } from 'framer-motion'
import { useRef } from 'react'

const CollapsibleContent = ({
  children,
  isOpen = false,
  borderBottom = true,
  borderFull = true,
  disableAnimation = false
}) => {
  const contentRef = useRef(null)

  return (
    <AnimatePresence>
      {isOpen && (
        <CollapsibleContainer
          ref={contentRef}
          borderBottom={borderBottom}
          borderFull={borderFull}
          // Usar animação de escala em vez de altura
          initial={
            disableAnimation
              ? false
              : {
                  height: 0,
                  opacity: 0,
                  overflow: 'hidden'
                }
          }
          animate={
            disableAnimation
              ? undefined
              : {
                  height: 'auto',
                  opacity: 1,
                  overflow: 'visible'
                }
          }
          exit={
            disableAnimation
              ? false
              : {
                  height: 0,
                  opacity: 0,
                  overflow: 'hidden'
                }
          }
          transition={
            disableAnimation
              ? { duration: 0 }
              : {
                  height: { type: 'spring', stiffness: 300, damping: 20 },
                  opacity: { duration: 0.2 },
                  duration: 0.3,
                  ease: [0.4, 0, 0.2, 1] // Curva de easing mais suave
                }
          }
        >
          {children}
        </CollapsibleContainer>
      )}
    </AnimatePresence>
  )
}

export default CollapsibleContent
